var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52551 13.25H9.64315V11.75H3.52551V13.25ZM3.52551 9.25H12.4667V7.75H3.52551V9.25ZM3.52551 5.25H12.4667V3.75H3.52551V5.25ZM1.69751 17C1.22205 17 0.819623 16.825 0.490211 16.475C0.1608 16.125 -0.00390625 15.6974 -0.00390625 15.1923V1.80775C-0.00390625 1.30258 0.1608 0.875 0.490211 0.525C0.819623 0.175 1.22205 0 1.69751 0H14.2947C14.7701 0 15.1726 0.175 15.502 0.525C15.8314 0.875 15.9961 1.30258 15.9961 1.80775V15.1923C15.9961 15.6974 15.8314 16.125 15.502 16.475C15.1726 16.825 14.7701 17 14.2947 17H1.69751ZM1.69751 15.5H14.2947C14.3672 15.5 14.4335 15.4679 14.4937 15.4038C14.5541 15.3398 14.5843 15.2692 14.5843 15.1923V1.80775C14.5843 1.73075 14.5541 1.66025 14.4937 1.59625C14.4335 1.53208 14.3672 1.5 14.2947 1.5H1.69751C1.62503 1.5 1.55868 1.53208 1.49845 1.59625C1.43805 1.66025 1.40786 1.73075 1.40786 1.80775V15.1923C1.40786 15.2692 1.43805 15.3398 1.49845 15.4038C1.55868 15.4679 1.62503 15.5 1.69751 15.5Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.f293d784c4485545919e4d1fa4fbb513.svg";
export { ForwardRef as ReactComponent };